<template>
  <div class="bg_modal" v-if="isShowModal">
    <div
      class="my_modal"
      :style="{ width: modalWidth }"
      style="max-height: 95vh"
    >
      <div class="header_view" v-if="title">
        <div class="header_title">
          {{ title }}
        </div>
        <div class="header_close" v-if="isClose" @click="modalCloseClick"><img src="@/assets/index/modal_close.png" alt=""> </div>
      </div>
      <slot name="modalHeader"> </slot>
      <div style="max-height: 70vh;overflow-y:auto;overflow-x:hidden">
        <slot name="modalMIddle"> </slot>
      </div>
      <slot name="modalFooter"> </slot>
    </div>
    <div class="bg_modal_second" @click="ModleClose"> </div>
  </div>
</template>

<script>
export default {
  name: "myModal",
  props: {
    title: {
      type: String,
      default: "",
    },
    isClose: {
      type: Boolean,
      default: false,
    },
    modalWidth: {
      type: String,
      default: "",
    },
    isClickBgcClose:{
       type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      pageInitId: "",
      isShowModal: false,
    };
  },
  methods: {
    ModleClose() {
      if(this.isClickBgcClose){
      this.isShowModal = false;
      }
    },
    modalCloseClick(){
      this.isShowModal = false;
      this.$emit('modalCloseClick')
    }
  },
};
</script>

<style scope>
.bg_modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(26, 26, 26, 0.5);
  animation: all 0.5s ease;
 
}
 .bg_modal_second {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  .my_modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 12px;
    z-index: 1001;
   padding: 20px;  
   box-sizing: border-box;
  }
    .header_view {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #F5F6F6;

    }
     .header_title {
        flex: 11;
        text-align: center;
        font-size: 16px;
        color: #1a1a1a;
      }

      .header_close {
        flex: 1;
        cursor: pointer;
      }
</style>



// WEBPACK FOOTER //
// src/components/myModal.vue